module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_7042.a68c6442.png";